
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[link]",
      function () {
        return require("private-next-pages/product/[link]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[link]"])
      });
    }
  